import React, { ReactNode } from 'react'

import { DialogActions as MUIDialogActions } from '@mui/material'

interface DialogActionsProps {
  children: ReactNode
  disableSpacing?: boolean
  sx?: object
}

/**
 * [INSERT DESCRIPTION]
 */

const DialogActions = React.forwardRef(
  (props: DialogActionsProps, ref: any) => {
    const { children, ...rest } = props

    return (
      <MUIDialogActions {...rest} ref={ref}>
        {children}
      </MUIDialogActions>
    )
  }
)

DialogActions.displayName = 'DialogActions'
export default DialogActions
